/* eslint-disable */
import React from 'react';
import SEO from './SEO';
import './styles/styles.css';

const containerStyle = {
  minHeight: '60vh',
  backgroundColor: '#FFF',
  padding: '4rem 2rem',
  fontFamily: 'Raleway, sans-serif',
};

const innerStyle = {
  maxWidth: 760,
  margin: '0 auto',
};

const h1Style = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2.25rem',
  fontWeight: 700,
  color: '#261136',
  marginBottom: '0.25rem',
};

const metaStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.9rem',
  color: '#888',
  marginBottom: '2.5rem',
};

const h2Style = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.3rem',
  fontWeight: 700,
  color: '#261136',
  marginTop: '2rem',
  marginBottom: '0.5rem',
};

const pStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.97rem',
  color: '#444',
  lineHeight: 1.7,
  marginBottom: '0.75rem',
};

const PublicTerms = () => (
  <>
    <SEO
      title="Terms of Service | Bins Storage"
      description="Read the Bins Storage terms of service – the rules and conditions for using our valet storage platform."
      path="/terms"
    />
    <div style={containerStyle}>
      <div style={innerStyle}>
        <h1 style={h1Style}>Terms of Service</h1>
        <p style={metaStyle}>Last updated: April 2026</p>

        <p style={pStyle}>
          By accessing or using the Bins Storage platform (website and mobile
          application), you agree to be bound by these Terms of Service. Please read
          them carefully.
        </p>

        <h2 style={h2Style}>1. Use of Services</h2>
        <p style={pStyle}>
          Bins Storage provides a platform connecting tenants with storage facilities
          and drivers for valet storage services. You must be at least 18 years old
          to use our services. You agree to provide accurate information during
          signup and to keep your account credentials secure.
        </p>

        <h2 style={h2Style}>2. Storage Services</h2>
        <p style={pStyle}>
          Storage unit terms, pricing, and availability are determined by the
          individual storage facilities in our network. By reserving a unit, you
          agree to the specific facility's lease terms, which will be presented to
          you before confirmation.
        </p>

        <h2 style={h2Style}>3. Pickup and Delivery</h2>
        <p style={pStyle}>
          Pickup and delivery services are subject to availability, scheduling
          windows, and applicable fees. Moving fees are displayed upfront before
          you confirm your reservation. Cancellations must be made at least 48 hours
          in advance to avoid fees.
        </p>

        <h2 style={h2Style}>4. Prohibited Items</h2>
        <p style={pStyle}>
          You may not store hazardous materials, flammable substances, perishables,
          living things, illegal items, or any items prohibited by the facility's
          policies or applicable law.
        </p>

        <h2 style={h2Style}>5. Liability</h2>
        <p style={pStyle}>
          While every facility in our network includes insurance coverage, Bins
          Storage's liability is limited to the terms stated in your facility lease
          agreement. We are not responsible for losses caused by circumstances
          beyond our reasonable control.
        </p>

        <h2 style={h2Style}>6. Payments</h2>
        <p style={pStyle}>
          You authorize Bins Storage to charge your payment method on the dates and
          amounts agreed upon during signup. Monthly storage charges are billed on
          the anniversary of your move-in date.
        </p>

        <h2 style={h2Style}>7. Termination</h2>
        <p style={pStyle}>
          Either party may terminate services with appropriate notice as specified in
          your facility lease agreement. Outstanding balances must be settled before
          items are released.
        </p>

        <h2 style={h2Style}>8. Changes to Terms</h2>
        <p style={pStyle}>
          We may update these Terms from time to time. Continued use of the platform
          after changes constitutes acceptance of the updated Terms.
        </p>

        <h2 style={h2Style}>9. Contact</h2>
        <p style={pStyle}>
          For questions about these Terms, contact us at{' '}
          <a href="mailto:contact@bins-storage.com" style={{ color: '#7B1FA2' }}>
            contact@bins-storage.com
          </a>.
        </p>
      </div>
    </div>
  </>
);

export default PublicTerms;
